import React, { useState, useEffect } from "react";
import axios from "axios";
import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";

const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [seminarName, setSeminarName] = useState("");
  const [message, setMessage] = useState("");
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const LOCAL_URL = "https://api.revicon.info"; // Zamijeni sa svojom lokalnom IP adresom
    const EXTERNAL_URL = "https://api.revicon.info"; // Vanjski URL
 
  useEffect(() => {
    fetchSessions();
  }, []);
 
  const fetchSessions = async () => {
    try {
        // Prvo pokušaj dohvatiti podatke s lokalnog servera
        const response = await axios.get(`${LOCAL_URL}/sessions`, { timeout: 2000 }); // 2 sekunde timeout
        console.log("Koristim lokalni server:", `${LOCAL_URL}/sessions`);
        setSessions(response.data);
    } catch (error) {
        console.warn("Lokalni server nije dostupan, prebacujem na vanjski:", `${EXTERNAL_URL}/sessions`);
        try {
            // Ako lokalni ne radi, pokušaj dohvatiti podatke s vanjskog servera
            const response = await axios.get(`${EXTERNAL_URL}/sessions`);
            setSessions(response.data);
        } catch (error) {
            console.error("Greška pri dohvaćanju sesija", error);
        }
    }
};
 
 
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
 
  const handleUpload = async () => {
    if (!file || !seminarName.trim()) {
        setMessage("Molimo odaberite fajl i unesite naziv seminara.");
        return;
    }
 
    const formData = new FormData();
    formData.append("file", file);
    formData.append("seminarName", seminarName);
 
    try {
        // Pokušaj poslati fajl na lokalni server
        const response = await axios.post(`${LOCAL_URL}/upload`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
            timeout: 5000 // Timeout 5 sekundi
        });
        console.log("Fajl poslan na lokalni server:", `${LOCAL_URL}/upload`);
        setMessage("Fajl uspješno poslan! " + response.data.message);
    } catch (error) {
        console.warn("Lokalni server nije dostupan, prebacujem na vanjski:", `${EXTERNAL_URL}/upload`);
        try {
            // Ako lokalni ne radi, pokušaj poslati fajl na vanjski server
            const response = await axios.post(`${EXTERNAL_URL}/upload`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            setMessage("Fajl uspješno poslan! " + response.data.message);
        } catch (error) {
            setMessage("Greška prilikom slanja fajla.");
            console.error("Greška prilikom slanja fajla:", error);
        }
    }
 
    setSeminarName("");
    fetchSessions(); // Osvježi sesije nakon slanja
};
 
const handleProcessSession = async () => {
  if (!selectedSession) {
      setMessage("Molimo odaberite sesiju za prikaz.");
      return;
  }
 
  console.log("Pokušavam dohvatiti pitanja za sesiju ID:", selectedSession);
 
  try {
      // Pokušaj dohvatiti s lokalnog servera
      const response = await axios.get(`${LOCAL_URL}/questions/${selectedSession}`, { timeout: 3000 });
      console.log("Pitanja dohvaćena s lokalnog servera:", response.data);
      setQuestions(response.data);
      setMessage("Pitanja uspješno dohvaćena!");
  } catch (error) {
      console.warn("Lokalni server nije dostupan, prebacujem na vanjski:", EXTERNAL_URL);
      try {
          const response = await axios.get(`${EXTERNAL_URL}/questions/${selectedSession}`);
          console.log("Pitanja dohvaćena s vanjskog servera:", response.data);
          setQuestions(response.data);
          setMessage("Pitanja uspješno dohvaćena!");
      } catch (error) {
          console.error("Greška prilikom dohvaćanja pitanja:", error.response?.data || error.message);
          setMessage("Greška prilikom dohvaćanja pitanja.");
      }
  }
};
  const formatInitials = (name) => {
    if (!name) return "NN:";
    const parts = name.split(" ");
    return parts.length > 1 ? `${parts[0][0]}${parts[1][0]}:` : `${parts[0][0]}`;
  };

   // generisanje word dokumenta 
  //  const generateWordDocument = () => {
  //   const doc = new Document({
  //     sections: [
  //       {
  //         properties: {},
  //         children: [
  //           new Paragraph({
  //             children: [
  //               new TextRun({ text: `Seminar: ${seminar_Name}`, bold: true, size: 28 }),
  //             ],
  //             spacing: { after: 200 },
  //           }),
  //           new Paragraph({
  //             children: [
  //               new TextRun({ text: "Lista pitanja i odgovora", bold: true, size: 24 }),
  //             ],
  //             spacing: { after: 100 },
  //           }),
  //           ...Object.entries(questions).flatMap(([participant, qs]) => [
  //             new Paragraph({
  //               children: [
  //                 new TextRun({ text: formatInitials(participant), bold: true, size: 22,color: "ff0000"}),
  //               ],
  //               spacing: { after: 50 },
  //             }),
  //             ...qs.flatMap((q, index) => [
  //               new Paragraph({
  //                 children: [
  //                   new TextRun({ text: `${q.question}`, bold: true }),
  //                 ],
  //               }),
  //               new Paragraph({
  //                 children: [new TextRun({ text: "R:", bold: true, color: "ff0000" })],
  //               }),
  //               new Paragraph({
  //                 children: [new TextRun({ text: q.answer || "nema odgovora", italics: true })],
  //                 spacing: { after: 200 },
  //               }),
  //             ]),
  //           ]),
  //         ],
  //       },
  //     ],
  //   });

  //   Packer.toBlob(doc).then((blob) => {
  //     saveAs(blob, `Pitanja_${seminarName.replace(/\s+/g, "_")}.docx`);
  //   });
  // };
  const generateWordDocument = () => {
    // Pronađi naziv seminara za odabranu sesiju
    const selectedSessionData = sessions.find(session => session.id === parseInt(selectedSession, 10));
    const seminarName = selectedSessionData ? selectedSessionData.seminar_name : "Nepoznati seminar";

    const doc = new Document({
        sections: [
            {
                properties: {},
                children: [
                    new Paragraph({
                        children: [
                            new TextRun({ text: `Seminar: ${seminarName}`, bold: true, size: 28 }),
                        ],
                        spacing: { after: 200 },
                    }),
                    new Paragraph({
                        children: [
                            new TextRun({ text: "Lista pitanja i odgovora", bold: true, size: 24 }),
                        ],
                        spacing: { after: 100 },
                    }),
                    ...Object.entries(questions).flatMap(([participant, qs]) =>
                        qs.flatMap((q, index) => [
                            new Paragraph({
                                children: [
                                    new TextRun({ text: `${formatInitials(participant)} `, bold: true, size: 22, }),
                                ],
                            }),
                            new Paragraph({
                              children: [
                                  new TextRun({ text: `${q.question}`,}),
                              ],
                          }),
                            new Paragraph({
                                children: [new TextRun({ text: "R:", bold: true, color: "#ff000d" })],
                            }),
                            new Paragraph({
                                children: [new TextRun({ text: q.answer || "nema odgovora",})],
                                spacing: { after: 200 },
                            }),
                        ])
                    ),
                ],
            },
        ],
    });

    Packer.toBlob(doc).then((blob) => {
        saveAs(blob, `Pitanja_${seminarName.replace(/\s+/g, "_")}.docx`);
    });
};



  const getAnsweredQuestionsCount = (questions) => {
    if (!questions || typeof questions !== "object") return 0;
  
    return Object.values(questions)
      .flat()
      .filter(q => q?.answer?.trim() && q.answer.trim().toLowerCase() !== "nema odgovora")
      .length;
  };
  
  // Koristi ovu funkciju da tačno broji odgovore
  const answeredQuestionsCount = getAnsweredQuestionsCount(questions);
  
  // Brojanje live odgovorenih pitanja ostaje isto
  const liveAnsweredCount = Object.values(questions)
    .flat()
    .filter(q => q.answer && q.answer.trim().toLowerCase() === "live answered")
    .length;
  

  return (
    
    <div style={{ maxWidth: "1200px", margin: "20px auto", padding: "20px", border: "1px solid #ddd", borderRadius: "10px", boxShadow: "0px 0px 10px rgba(0,0,0,0.1)", fontFamily: "Arial, sans-serif", backgroundColor: "#fff" }}>
      <h2 style={{ textAlign: "center", color: "#333" }}>Upload pitanja (Excel/CSV)</h2>
      
      <input
        type="text"
        placeholder="Unesite naziv seminara"
        value={seminarName}
        onChange={(e) => setSeminarName(e.target.value)}
        style={{ display: "block", margin: "10px auto", padding: "10px", width: "90%" }}
      />

      <input type="file" accept=".csv,.xlsx" onChange={handleFileChange} style={{ display: "block", margin: "10px auto" }} />
      <button onClick={handleUpload} style={{ display: "block", margin: "10px auto", padding: "10px 20px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}>Pošalji</button>
      {message && <p style={{ textAlign: "center", color: "#d9534f" }}>{message}</p>}
{/*    */}

      <h2 style={{ textAlign: "center", color: "#333" }}>Odaberi sesiju za prikaz pitanja</h2>
      <select onChange={(e) => setSelectedSession(e.target.value)} style={{ display: "block", margin: "10px auto", padding: "10px", width: "100%" }}>
        <option value="">-- Odaberi sesiju --</option>
        {sessions.map((session) => (
          <option key={session.id} value={session.id}>
            {session.seminar_name} 
          </option>
        ))}
      </select>
      <button onClick={handleProcessSession} style={{ display: "block", margin: "10px auto", padding: "10px 20px", backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}>Prikaži pitanja</button>

      {questions && Object.keys(questions).length > 0 && (
  <div style={{ marginTop: "20px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }}>
    <h2 style={{ textAlign: "center", color: "#333" }}>
      Obrađena pitanja: <span style={{ color: "#d9534f" }}>{sessions.seminar_name}</span>
    </h2>
    {Object.entries(questions).map(([participant, qs]) => {
      // Filtriraj pitanja koja nemaju odgovor "Nema odgovora"
      const filteredQuestions = qs.filter(q => q.answer && q.answer !== "nema odgovora");

      return filteredQuestions.length > 0 ? (
        <div key={participant} style={{ marginBottom: "15px", padding: "10px", backgroundColor: "#f9f9f9", borderRadius: "5px" }}>
          <h3 style={{ color: "#007bff" }}>{formatInitials(participant)}</h3>
          {filteredQuestions.map((q, index) => (
            <div key={index} style={{ padding: "5px 0" }}>
              <p>{q.question}</p>
              <p style={{ color: "red", fontWeight: "bold" }}>Revicon</p>
              <p><em>{q.answer}</em></p>
            </div>
          ))}
        </div>
      ) : null; // Ako nema pitanja, ne prikazuje prazan div
    })}
  </div>
)}

{questions && Object.keys(questions).length > 0 && (
  <button onClick={generateWordDocument} style={{ display: "block", margin: "20px auto", padding: "10px 20px", backgroundColor: "#ffc107", color: "#000", border: "none", borderRadius: "5px", cursor: "pointer" }}>
    Preuzmi Word dokument
  </button>
)}
</div>
  );
};

export default FileUpload;
